<template>

  <month-base-bar>
    {{ item.spacesSold }} – On-Demand
  </month-base-bar>

</template>

<script setup lang="ts">

import MonthBaseBar from './MonthBaseBar.vue'
import type { MonthOnDemandCalendarItem } from '../../calendarItemTypes'

/**
 * Props
 */

interface Props {
  item: MonthOnDemandCalendarItem
}

defineProps<Props>()

</script>
